import { Component, viewChild } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete'
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Reimbursementservice } from './../reimbursement.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { NgxLoadingComponent } from '../../../shared/components/ngx-loading/ngx-loading.component';

@Component({
    selector: 'formly-field-ngx-google-places-autocomplete',
    template: `
    <div class="mb-3">
      <label>{{field.templateOptions.label}}</label>
      <!-- <input
        ngx-google-places-autocomplete
        class='form-control'
        [formControl]="formControl"
        [formlyAttributes]="field"
        (onAddressChange)="handleAddressChange($event)"
      /> -->
      <formly-validation-message
        *ngIf="showError"
        [field]="field"
      >
      </formly-validation-message>
    </div>
    <ngx-loading [show]="loading"></ngx-loading>

  `,
    imports: [FormsModule, ReactiveFormsModule, FormlyModule, NgIf, NgxLoadingComponent]
})

export class NgxGooglePlacesAutocompleteComponent extends FieldType {

  readonly placesRef = viewChild<GooglePlaceDirective>("placesRef");
  loading = false

  constructor(private remService: Reimbursementservice) {
    super();
  }

  handleAddressChange(address: Address) {
    const key: any = this.key
    this.model[key] = address.formatted_address

    if (this.model.location_from && this.model.location_to) {
      this.loading = true;

      const params = {
        category_id: this.model.category_id,
        location_from: this.model.location_from,
        location_to: this.model.location_to,
        currency: this.model.currency
      }

      this.remService.newReimbursement(params).subscribe(res => {
        this.loading = false;
        if (res['reimbursement']) {
          const system_calculated_km = (<HTMLInputElement> document.getElementById("system_calculated_km"))
          system_calculated_km.value = res['reimbursement']['data']['system_calculated_km']
        }
      }, (err) => {
        this.loading = false;
      });
    }
  }

}
